import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { SvgIcon } from "@mui/material";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
  icon: {
    color: "white",
    width: theme.spacing(1.5),
    height: theme.spacing(2.25)
  }
}));

function TableSortIcon(props) {
  const classes = useStyles();
  return (
    <SvgIcon classes={{ root: classes.icon }} onClick={props.onClick}>
      <g id="surface1">
        <path
          opacity={props.sortDirection === "desc" ? "1" : "0.4"}
          d="M 6.960938 5.398438 L 2.28125 10.078125 L 21.160156 10.078125 L 16.480469 5.398438 C 13.902344 2.824219 11.769531 0.71875 11.71875 0.71875 C 11.671875 0.71875 9.535156 2.824219 6.960938 5.398438 Z M 6.960938 5.398438 "
        />
        <path
          opacity={props.sortDirection === "asc" ? "1" : "0.4"}
          d="M 7 18.640625 L 11.71875 23.359375 L 16.414062 18.664062 C 19.007812 16.070312 21.121094 13.953125 21.121094 13.945312 C 21.121094 13.929688 16.878906 13.921875 11.703125 13.921875 L 2.28125 13.921875 Z M 7 18.640625 "
        />
      </g>
    </SvgIcon>
  );
}

export default TableSortIcon;

TableSortIcon.propTypes = {
  sortDirection: PropTypes.oneOf(["asc", "desc", ""]),
  onClick: PropTypes.func
};
